<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title> Terms and Conditions </glxy-page-title>
  </glxy-page-toolbar>
  <glxy-page-wrapper [widthPreset]="'full'">
    <mat-card appearance="outlined">
      <mat-card-content>
        @if (terms) {
          <p [innerHTML]="terms | iTrustThisHtml"></p>
        }
        @if (!terms || submitting) {
          <mat-spinner></mat-spinner>
        }
      </mat-card-content>
      <mat-card-actions>
        <div class="tos-actions">
          <mat-checkbox color="primary" #accept>I agree to the Terms & Conditions</mat-checkbox>

          <div class="actions">
            <button
              class="tos-submit"
              mat-raised-button
              color="primary"
              [disabled]="!accept.checked || !terms || submitting"
              (click)="acceptTerms()"
              >
              Continue
            </button>

            <a href="/logout" mat-stroked-button [disabled]="submitting">Logout</a>
          </div>
        </div>
      </mat-card-actions>
    </mat-card>
    <div class="partner-info">{{ partnerName$ | async }} ({{ partnerId$ | async }})</div>
  </glxy-page-wrapper>
</glxy-page>
